/* eslint-disable max-len */
/* eslint-disable eqeqeq */
/* eslint-disable react/no-unused-state */
import React from 'react';

import queryString from 'query-string';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { NavLink } from 'react-router-dom';
import ProductsData from '../../data/products';

import 'react-tippy/dist/tippy.css';

import ROUTES from '../../data/routes';
import Helper from '../../helpers/string';

class NavMenuCategories extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      maxSubMenuInBottom: ProductsData.maxSubMenuInBottom, // 5 sub
      renderMenuType: 'login',
      principalCategories: [],
      subCategories: [],
    };
  }

  componentDidMount() {
    const { categories } = this.props;

    this.filterCategories(categories);
  }

  checkSustainable = (category, left = false) => {
    if (left && category.isSustainable) return { flex: 5, color: '#00b200' };
    if (category.isSustainable) return { color: '#00b200' };
  };

  filterCategories = (categories = []) => {
    const principalCategories = [];
    const subCategories = [];

    categories.forEach((category) => {
      if (['PORTFÓLIO VERDE', 'PROMOÇÃO DO MÊS', 'EPI E EPC', 'ELÉTRICA'].includes(category.name.toUpperCase())) {
        principalCategories.push(category);
      } else {
        subCategories.push(category);
      }
    });

    this.setState({
      principalCategories,
      subCategories,
    });
  };

  renderCategories = () => {
    const { principalCategories, subCategories } = this.state;

    return (
      <div className="nav">
        <ul className="nav-ul">
          <li>
            <NavLink
              activeClassName="destak"
              to="/"
              isActive={(match, location) => location.pathname === '/'}
            >
              {I18n.t('home')}
            </NavLink>
          </li>

          <li className="sub">
            <NavLink
              activeClassName="active"
              to={ROUTES.PRODUCTS}
              isActive={(match, location) => {
                const params = queryString.parse(location.search);
                return params.categories || (location.pathname == ROUTES.PRODUCTS && Object.getOwnPropertyNames(params).length == 0);
              }}
            >
              {I18n.t('categories')}
            </NavLink>

            <div className="content-sub content-sub-mobile visible-when-active">
              <ul className="sub-ul">
                {subCategories.map(subCategory => (
                  <li key={subCategory.id} className="cat">
                    <NavLink
                      activeClassName="active"
                      to={`${ROUTES.PRODUCTS}?categories=${subCategory.id}`}
                      isActive={(match, location) => {
                        const params = queryString.parse(location.search);
                        return params.categories == subCategory.id;
                      }}
                    >
                      {Helper.capitalizeFirstLetter(subCategory.name)}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </li>

          {principalCategories.map(category => (
            <li className="sub" key={category.id}>
              <NavLink
                activeClassName="active"
                to={`${ROUTES.PRODUCTS}?categories=${category.id}&type=greenOffer`}
                style={this.checkSustainable(category)}
                isActive={(match, location) => {
                  const params = queryString.parse(location.search);
                  return params.categories == category.id || category.categories.find(sub => sub.id == params.categories);
                }}
              >
                {Helper.capitalizeFirstLetter(category.name)}
              </NavLink>

              {category.categories && category.categories.length > 0 && (
              <div className="content-sub content-sub-mobile visible-when-active">
                <ul className="sub-ul">
                  {category.categories.map(subCategory => (
                    <li key={subCategory.id} className="sub-cat">
                      <NavLink
                        activeClassName="active"
                        to={`${ROUTES.PRODUCTS}?categories=${subCategory.id}&type=greenOffer`}
                        isActive={(match, location) => {
                          const params = queryString.parse(location.search);
                          return params.categories == subCategory.id;
                        }}
                      >
                        {Helper.capitalizeFirstLetter(subCategory.name)}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        <nav className="nav">
          <ul className="nav-ul headerCategories headerFlexCategories">
            <li>{this.renderCategories()}</li>
          </ul>
        </nav>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
});

export default connect(mapStateToProps, undefined)(NavMenuCategories);
